import { Theme } from './../index.d';
import UI_THEME_DEFAULT from './UI_THEME_DEFAULT';

const UI_THEME_BANVOX: Theme = {
  pallete: {
    ...UI_THEME_DEFAULT.pallete,
  },
  brand: {
    ...UI_THEME_DEFAULT.brand,
    name: 'Banvox',
    company_name: 'Banvox Distribuidora de Títulos e Valores Mobiliários Ltda',
    company_cnpj: '02.671.743/0001-19',
    desc: 'Módulo de cadastro',
    prefix: 'banvox',
    footerText: `Banvox - Todos os direitos reservados ${new Date().getFullYear()}`,
    logoText: 'Banvox',
    logoWidth: 50,
    minWidth: 50,
    logo: '/assets/banvox/logo.png',
    logoHorizontal: '/assets/banvox/logo.png',
    favicon: '/assets/favicon/banvox-favicon.ico',
    simplifiedFund: false,
  },
  api: {
    ...UI_THEME_DEFAULT.api,
    local: 'http://127.0.0.1:8000',
    // local: 'https://stage.api.data.banvox.prosperita.io',
    dev: 'https://dev.api.data.banvox.prosperita.io',
    stage: 'https://stage.api.data.banvox.prosperita.io',
    prod: 'https://api.data.banvox.prosperita.io',
    clarity_id: 'fhco559uuk',
    sentry_dsn:
      'https://561c977b8b3148de9e15e4e241b2e6ca@sentry.tools.prosperita.io/25',
  },
};

export default UI_THEME_BANVOX;
